var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElementElectro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 314.09 314.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#af8ec1;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_10",
    "data-name": "Livello 10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270,217.38l0,0a127.47,127.47,0,0,1-160.49,57.53c.77.05,43.6,2.93,57.78-7.87,0,0-69.5-8.18-68.47-83.46,0,0,8.51,14.64,23.84,14.64s25.89-18.39,25.89-36.45-21.46-41.22-45.65-41.22S38.61,141.08,47.78,221.07A127.39,127.39,0,0,1,80.21,56.12C79.26,57.54,55.83,92.51,58,110c0,0,42-56,106.57-17.28,0,0-17,0-24.65,13.26s2.9,31.62,18.51,40.69,46.43,2.15,58.58-18.76S231.57,62,157.81,29.71h.05A127.36,127.36,0,0,1,283.55,136.58c-.62-1.17-20.39-38.71-36.9-45.1.42.93,28.88,63.79-35.34,102,0,0,8-14.92,0-28s-29.22-12.45-44.61-3-23.9,39.85-11.26,60.47S206.61,267,270,217.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 314.09,
    height: 314.09
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementElectro);
export default __webpack_public_path__ + "static/media/Element_Electro.178efeba7aa67dca8d20a69fdcaebfaa.svg";
export { ForwardRef as ReactComponent };